import * as React from "react";
import { debounce } from "throttle-debounce";
import { Context } from "@grandvisionhq/carts-v2";
import { Button } from "@grandvisionhq/common";
import { Divider } from "@grandvisionhq/elements";
import { Form, FormGroup } from "@grandvisionhq/forms";
import { createSlotsContext } from "@grandvisionhq/slots";
import { useIntl } from "@grandvisionhq/state";
const [FormSlotsProvider, useBaseFormSlot] = createSlotsContext({
  displayName: "FormSlotsContext"
});
const useIsFormSlotAvailable = (formName) => {
  const { Slots } = useBaseFormSlot();
  return Boolean(Slots[formName]);
};
const useFormSlotWithoutRedux = (props) => {
  const { Slots } = useBaseFormSlot();
  const cartContext = React.useContext(Context.CartContext);
  const { getLabel } = useIntl();
  const cartContainsContactLenses = cartContext?.cart?.contains.contactLenses;
  const cartContainsSolutions = cartContext?.cart?.contains.solutions;
  const cartContainsPrescriptionGlasses = cartContext?.cart?.contains.prescriptionGlasses;
  const cartContainsSunglasses = cartContext?.cart?.contains.sunglasses;
  const cartContainsSubscription = cartContext?.cart?.contains.subscription;
  const handleChange = React.useCallback(
    (formData) => {
      props?.onChange && props?.onChange(formData);
    },
    [props]
  );
  const debouncedHandleChange = React.useMemo(() => {
    return debounce(200, handleChange);
  }, [handleChange]);
  const forms = Object.entries(Slots).reduce((formItem, [key, Slot]) => {
    const formData = props?.formInitialData[key] ? props?.formInitialData[key] : void 0;
    formItem[key] = /* @__PURE__ */ React.createElement(
      Form,
      {
        name: key,
        "data-t": key,
        initialFormState: formData,
        onChange: debouncedHandleChange,
        ref: props?.formRef,
        onSubmit: props?.onSubmit,
        className: props?.className
      },
      /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "form-content__fields" }, /* @__PURE__ */ React.createElement(
        Slot,
        {
          cartContainsContactLenses,
          cartContainsSolutions,
          cartContainsSunglasses,
          cartContainsSubscription,
          cartContainsPrescriptionGlasses,
          disableFields: props?.disableFields
        }
      )), Boolean(props?.onSubmit) ? /* @__PURE__ */ React.createElement("div", { className: "form-content__footer" }, /* @__PURE__ */ React.createElement(Divider, { className: "form-content__footer-divider" }), /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(
        Button,
        {
          caption: getLabel("common.actions.cancel"),
          "aria-label": getLabel("common.actions.cancel"),
          onClick: props?.onCancel,
          variant: "outline"
        }
      ), /* @__PURE__ */ React.createElement(
        Button,
        {
          type: "submit",
          variant: "solid",
          "aria-label": getLabel("common.actions.save"),
          caption: getLabel("common.actions.save")
        }
      ))) : null)
    );
    return formItem;
  }, {});
  return forms;
};
export {
  FormSlotsProvider,
  useBaseFormSlot,
  useFormSlotWithoutRedux,
  useIsFormSlotAvailable
};
//# sourceMappingURL=form-context.js.map
